import React from 'react';
import classnames from 'classnames';

import './style.scss';

const Author = ({ name, avatar, workfield, className, isSmall }) => {
  return (
    <div className={classnames(className, 'Author', { AuthorLarge: !isSmall })}>
      <div className="Author__details">
        <div className="Author__details__avatar"><img alt={`Foto van ${name}`} src={avatar} /></div>
        <div className="Author__details__info">
          <div className="Author__details__workfield">{ workfield }</div>
          <span className="Author__details__name">{ name }</span>
        </div>
      </div>
    </div>
  );
};

export default Author;
